// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';

// INNER IMPORTS
import './CheckboxRound.css';
import SVGInline from "react-svg-inline";
import viSVG from "../../inlineSVGs/viSVG";

const CheckboxRound = ({ isChecked, onToggle, color = '#888888', activeColor = '#8021fc' }) => {

    return (
        <div className="checkbox-round-wrapper" onClick={() => onToggle()} >
            <div
                className="outer-circle"
                style={{ borderColor: isChecked ? activeColor : color }}
            >
                {isChecked ?
                    <SVGInline
                        className="icon-vi"
                        svg={viSVG(isChecked ? activeColor : color)}
                        component="i"
                    /> : null
                }
            </div>
        </div>
    )
};

CheckboxRound.propTypes = {
    isChecked: PropTypes.bool,
    style: PropTypes.object,
    color: PropTypes.string,
    activeColor: PropTypes.string,
    onToggle: PropTypes.func
};

export default CheckboxRound;



// WEBPACK FOOTER //
// ./src/Components/Elements/Inputs/CheckboxRound.js